import {
    ATTENDANCE_REQUEST,
    ATTENDANCE_APPROVAL,
    ATTENDANCE_LIST
} from "./type";

const initialState = {
    makeAttendanceRequest:[],
    attendanceList:[],
};

const AttendanceRegularization = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case ATTENDANCE_REQUEST:
            return {
                ...state,
                makeAttendanceRequest: payload,
            };
        case ATTENDANCE_LIST:
            return {
                ...state,
                attendanceList: payload,
            };
        default:
            return {...state};
    }
};

export default AttendanceRegularization;